<template>
    <div class="my-script-list">
        <Loading v-if="!loadingDone"/>
        <van-tabs v-if="loadingDone">
            <van-tab title="我的投稿">
                <van-list
                v-model="scirptLoading"
                :finished="scirptFinished"
                finished-text="没有更多啦~"
                :error.sync="scirptError"
                error-text="请求失败  点击重新加载"
                @load="onMyScriptLoad"
                :offset=100
                :immediate-check="false"
                >
					<div class="empty" v-if="myScript.length==0"><img src="../assets/img/empty.png" alt=""></div>
                    <div class="msg-content-box" v-for="(item,index) in myScript" :key="index">
                        <div class="msg-content">
                            <div class="title-time">
                                <div class="title">{{item&&item.title}}</div>
                                <div class="time" :style="item&&item.over.value==1?'background:#bf0000':'background:#282828'">{{item&&item.over.name}}</div>
                            </div>
                            <div class="content">{{item&&item.intro}}</div>
                            <div class="author-type">
                                <div class="author">{{item&&item.writer_type==1?'编剧':'策划'}}：{{item&&item.writer_name}}</div>
                                <div class="type">{{item&&item.one_cateid_name}}·{{item&&item.two_cateid_name.join('·')}}</div>
                            </div>
                            <div class="date-review">
                                <div class="date">{{item&&item.created_at.substring(0,10)}}</div>
                                <div class="review" :style="item&&item.status==1?'color:#222':'color:#bf0000'">{{item&&item.status_name}}</div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-tab>
            <van-tab title="我的草稿">
                <van-list
                v-model="draftLoading"
                :finished="draftFinished"
                finished-text="没有更多啦~"
                :error.sync="draftError"
                error-text="请求失败  点击重新加载"
                @load="onMyDraftLoad"
                :offset=100
                :immediate-check="false"
                >
					<div class="empty" v-if="myDraft.length==0"><img src="../assets/img/empty.png" alt=""></div>
                    <div class="msg-content-box" v-for="(item,index) in myDraft" :key="index">
                        <div class="msg-content">
                            <div class="title-time">
                                <div class="title">{{item&&item.title}}</div>
                                <div class="time" :style="item&&item.over.value==1?'background:#bf0000':'background:#282828'">{{item&&item.over.name}}</div>
                            </div>
                            <div class="content">{{item&&item.intro}}</div>
                            <div class="author-type">
                                <div class="author">{{item&&item.writer_type==1?'编剧':'策划'}}：{{item&&item.writer_name}}</div>
                                <div class="type">{{item&&item.one_cateid_name}}·{{item&&item.two_cateid_name.join('·')}}</div>
                            </div>
                            <div class="date-review">
                                <div class="date">{{item&&item.created_at.substring(0,10)}}</div>
                                <div class="review" :style="item&&item.status==1?'color:#222':'color:#bf0000'">{{item&&item.status_name}}</div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
export default {
    name:'MyScriptList',
    data(){
        return{
            myScript:[],                      //储存我的投稿数据
            myDraft:[],                       //储存我的草稿数据
            scirptLoading: false,             //控制上划加载投稿状态显示
            scirptFinished: false,            //控制上划加载投稿完成状态显示
            scirptError: false,               //控制上划加载投稿出错状态显示

            draftLoading: false,             //控制上划加载草稿状态显示
            draftFinished: false,            //控制上划加载草稿完成状态显示
            draftError: false,               //控制上划加载草稿出错状态显示

            myScriptPageNum:0,               //加载投稿页码控制
            myDraftPageNum:0,                //加载草稿页码控制
 
            loadingDone:false                //控制加载画面显示隐藏
        }
    },
    created(){
		//获取我的投稿数据
        Axios.get('/article/contribute',{params:{page:this.myScriptPageNum,num:5}})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.myScript=response.data.data.lists
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
		)
		//获取我的草稿数据
        Axios.get('/article/draft',{params:{page:this.myDraftPageNum,num:5}})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.myDraft=response.data.data.lists
                    this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    methods:{
        //滚动时加载更多投稿
        onMyScriptLoad(){
            this.myScriptPageNum++
            Axios.get('/article/contribute',{params:{page:this.myScriptPageNum,num:5}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        if(response.data.data.lists.length==0){
                            this.scirptFinished=true
                            return false
                        }
                        this.myScript.push(...response.data.data.lists)
                        this.scirptLoading=false
                    }
                }
            ).catch(
                error=>{
                    this.scirptError=true
                    this.scirptLoading=false
                    console.log(error)
                }
            )
        },
        //滚动时加载更多草稿
        onMyDraftLoad(){
            this.myDraftPageNum++
            Axios.get('/article/draft',{params:{page:this.myDraftPageNum,num:5}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        if(response.data.data.lists.length==0){
                            this.draftFinished=true
                            return false
                        }
                        this.myDraft.push(...response.data.data.lists)
                        this.draftLoading=false
                    }
                }
            ).catch(
                error=>{
                    this.draftError=true
                    this.draftLoading=false
                    console.log(error)
                }
            )
        }
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
	.empty{
		background:#fff;
		height:280px;
		padding-top:200px;
		img{
			width:280px;
			height:280px;
			display:block;
			margin:0 auto;
		}
	}
    .my-script-list{
        width:750px;
        padding-top:88px;
        background:#F8F6F9;
    }
    /deep/.van-tab__text{
        font-size:30px !important;
    }
    /deep/.van-tabs--line .van-tabs__wrap{
        margin-bottom:10px !important;
        padding-top:12px;
        background:#fff;
    }
    .msg-content-box{
        padding:40px 40px 22px 40px;
        background:#fff;
        margin-bottom:10px;
        .msg-content{
            width:660px;
            .title-time{
                height:32px;
                margin-bottom:26px;
                .title{
                    font-size:26px;
                    color:#333;
                    float:left;
                    font-weight:bold;
                }
                .time{
                    font-size:20px;
                    color:#f7f7f7;
                    float:right;
                    height:30px;
                    width:76px;
                    text-align:center;
                    line-height:30px;
                    background:#282828;
                }
            }
            .content{
                font-size:24px;
                color:#999;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:3;
                overflow:hidden;
                text-overflow:ellipsis;
                line-height:38px;
                margin-bottom:38px;
            }
            .author-type{
                margin-bottom:22px;
				overflow:hidden;
                .author,.type{
                    font-size:24px;
                    color:#999;
                }
                .author{
                    float:left;
                }
                .type{
                    float:right;
                }
            }
            .date-review{
                height:30px;
				padding-top:12px;
				border-top:1px solid #E6E6E6;
                .date,.review{
                    font-size:24px;
                    color:#999;
                }
                .date{
                    float:left;
                }
                .review{
                    float:right;
                    color:#bf0000;
                }
            }
        }
    }
</style>
